module.exports = __webpack_public_path__ + "img/facebookIcon.f9f3bcb.png";